import { uploadFileToSignedMedia } from "../common/NubImageUpload/NubImageUpload.state";
import { getDefaultLegacyOverlayPayload, shouldSeedDefaultLegacyOverlay } from "./transformationPrompt";

/**
 * Turns a bundled image URL into a File so it can be uploaded to signed media.
 * @param {string} imageUrl
 * @param {string} [fileName]
 * @returns {Promise<File>}
 */
export const createFileFromImageUrl = async (imageUrl, fileName = "sample-background.png") => {
    const response = await fetch(imageUrl);
    if (!response.ok) {
        throw new Error(`Failed to load default background image (${response.status})`);
    }

    const blob = await response.blob();
    return new File([blob], fileName, { type: blob.type || "image/png" });
};

/**
 * Uploads the bundled default inpainting background when the challenge has no
 * remote overlay yet, then returns the challenge fields to persist.
 * @param {{
 *   assets?: Object,
 *   overlayMediaUuid?: string|null,
 *   imageUrl?: string,
 *   uploadFile?: Function,
 *   createFile?: Function,
 * }} params
 * @returns {Promise<Object>}
 */
export const getUploadedDefaultOverlayPayload = async ({
    assets,
    overlayMediaUuid,
    imageUrl,
    uploadFile = uploadFileToSignedMedia,
    createFile = createFileFromImageUrl,
}) => {
    if (!imageUrl || !shouldSeedDefaultLegacyOverlay(assets, overlayMediaUuid)) {
        return {};
    }

    const file = await createFile(imageUrl);
    const uploaded = await uploadFile(file);

    return getDefaultLegacyOverlayPayload({
        assets,
        overlayUrl: uploaded.mediaUrl,
        overlayUuid: uploaded.uuid,
        overlayExtension: uploaded.extension || "png",
    });
};
